import React from 'react';
import { VERSION } from '../../config';

// Components
import FullPageLayout from '../../components/FullPageLayout';
import { Container } from 'reactstrap';

const Version = ({ userId, cardNumber }) => (
  <FullPageLayout className="Version">
    <Container style={{paddingTop: '2rem', paddingBottom: '2rem'}}>

      <h1 className="Version_title">
        Version {VERSION}
      </h1>

      <div>User ID: {userId}</div>
      <div>Card Number: {cardNumber}</div>

    </Container>
  </FullPageLayout>
)

export default Version;



// WEBPACK FOOTER //
// ./src/pages/Version/Version.js